import { SHOW_UTENTE_MODAL, HIDE_UTENTE_MODAL } from "../actions/utenteModal_actions";
import _ from "lodash";

export function utenteModalReducer(state = { type:'', header: undefined, show: false, function: undefined, obj: undefined, buttonMessage: undefined, body: undefined }, action) {
  if (_.isEmpty(action) || _.isEmpty(action.type)) return state
  const newState = state
  switch (action.type) {
    case SHOW_UTENTE_MODAL:
      newState.type = action.payload.type
      newState.header = action.payload.header
      newState.show = true
      newState.function = action.payload.function
      newState.obj = action.payload.obj
      newState.buttonMessage = action.payload.buttonMessage
      newState.body = action.payload.body
      break;
    case HIDE_UTENTE_MODAL:
      newState.type = ''
      newState.header = undefined
      newState.show = false
      newState.function = undefined
      newState.obj = undefined
      newState.buttonMessage = undefined
      newState.body = undefined
      break;
    default:
      break;
  }
  return Object.assign({}, state, newState)
}
